import React from 'react';
import { channelLogoLookup } from './channel-logo-lookup';
import styled from '@emotion/styled';
const DEFAULT_SIZE = 48;
const StyledImage = styled.img `
	border-radius: 4px;
`;
export const ChannelLogo = ({ name, size = DEFAULT_SIZE, }) => {
    const src = channelLogoLookup[name];
    return (React.createElement(StyledImage, { src: src, alt: `channel-logo-${name}`, height: size, width: size }));
};
//# sourceMappingURL=ChannelLogo.js.map